import { ModuleSwitch } from "./ModuleSwitch";

// EOS-01 is one module with one sidebar entry, but two pages (Master Prompt A26 (i)): the
// projects page and the project revision's single-line diagram. This switch moves between
// them at the top of each page.
const PROJECT_CONFIG_PAGES = [
  { to: "/projects", label: "Project" },
  { to: "/sld", label: "Single-line diagram" },
] as const;

export function ProjectConfigSwitch() {
  return <ModuleSwitch label="Project configuration" pages={PROJECT_CONFIG_PAGES} />;
}

export default ProjectConfigSwitch;
